var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "UI-Elements/Icons/Calendar Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.796078 0 0 0 0 0.835294 0 0 0 0 0.878431 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pickup-Request-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pickup-Request-Creation---Stop-Recurring",
    transform: "translate(-707.000000, -417.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(570.000000, 413.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-Elements/Icons/Calendar-Copy",
    transform: "translate(138.000000, 5.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar(24x24)@1x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,20 L1,20 C0.45,20 0,19.55 0,19 L0,10 L20,10 L20,19 C20,19.55 19.55,20 19,20 Z",
    id: "Path",
    stroke: "#ABAFBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,3 L19,3 C19.55,3 20,3.45 20,4 L20,10 L0,10 L0,4 C0,3.45 0.45,3 1,3 L5,3",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,3 L19,3 C19.55,3 20,3.45 20,4 L20,10 L0,10 L0,4 C0,3.45 0.45,3 1,3 L5,3",
    id: "Path",
    stroke: "#ABAFBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 8,
    y2: 3,
    id: "Path",
    stroke: "#ABAFBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,6 C12.67,6 12,5.33 12,4.5 L12,1.5 C12,0.67 12.67,0 13.5,0 C14.33,0 15,0.67 15,1.5 L15,4.5 C15,5.33 14.33,6 13.5,6 Z",
    id: "Path",
    stroke: "#ABAFBD",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,6 C5.67,6 5,5.33 5,4.5 L5,1.5 C5,0.67 5.67,0 6.5,0 C7.33,0 8,0.67 8,1.5 L8,4.5 C8,5.33 7.33,6 6.5,6 Z",
    id: "Path",
    stroke: "#ABAFBD",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.5,
    y1: 17,
    x2: 16.5,
    y2: 17,
    id: "Path",
    stroke: "#ABAFBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.5,
    y1: 17,
    x2: 12.5,
    y2: 17,
    id: "Path",
    stroke: "#ABAFBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 17,
    x2: 8.5,
    y2: 17,
    id: "Path",
    stroke: "#ABAFBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 17,
    x2: 4.5,
    y2: 17,
    id: "Path",
    stroke: "#ABAFBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.5,
    y1: 13,
    x2: 16.5,
    y2: 13,
    id: "Path",
    stroke: "#ABAFBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.5,
    y1: 13,
    x2: 12.5,
    y2: 13,
    id: "Path",
    stroke: "#ABAFBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 13,
    x2: 8.5,
    y2: 13,
    id: "Path",
    stroke: "#ABAFBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 13,
    x2: 4.5,
    y2: 13,
    id: "Path",
    stroke: "#ABAFBD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "a5c8cbfa7be92e17b23638fa57daa9be.svg";
export { ForwardRef as ReactComponent };